<div *ngIf="pin != null" class="pin-info-container pin-project-container">
  <div class="pin-image">
    <div class="pin-date bag-count">
      <div class="bag-count">
        <span class="material-symbols-outlined">money_bag</span>
        <span>
        {{ pin.bag_count }}
          {{ 'HOMEPAGE.MAP.info_window.bags' | translate }}
      </span>
      </div>
    </div>

    <img [src]="pin.image" alt="" />
  </div>

  <div class="pin-tags">
    <a *ngFor="let category of pin.categories" class="pin-tag"
       [routerLink]="category.id | tagRouterLink:'project'"
       [queryParams]="category.id | tagQueryParams">
      {{ category.name }}
    </a>
  </div>

  <div class="pin-title">
    {{ pin.name }}
  </div>

  <ul class="pin-description">
    <li>
      <mat-icon fontIcon="calendar_month" class="material-icons-outlined"></mat-icon>
      <span>
        {{ pin.end_job_date | formattedDate }}
      </span>
    </li>

    <li>
      <mat-icon fontIcon="public" class="material-icons-outlined"></mat-icon>
      {{ 'COUNTRIES.' + pin.country | translate }},
      {{ 'CONTINENTS.' + pin.continent | translate }}
    </li>

    <li>
      <mat-icon fontIcon="account_circle" class="material-icons-outlined"></mat-icon>
      <span>
        {{ pin.hero.name }}
      </span>


    <li>
      <mat-icon fontIcon="credit_card" class="material-icons-outlined"></mat-icon>
      <span>
        {{ 'PROJECT.BOX.donates' | translate }}
        {{ pin.donation_money.amount | currencyAmount : pin.donation_money.currency }}

        <span *ngIf="pin.greencoin_activity != null && pin.greencoin_activity.coins > 0" class="green_coin_donation">
          <img src="/assets/img/greencoin_icon.png" alt="Greencoin" />
          {{ pin.greencoin_activity.coins }}
          {{ 'HOMEPAGE.MAP.info_window.green_coins' | translate }}
        </span>
      </span>
    </li>
  </ul>

  <div class="pin-button">
    <a [routerLink]="['/projects/verified/' + pin.id]" [innerHTML]="'HOMEPAGE.MAP.buttons.view_details' | translate"></a>
  </div>
</div>
